const CHANNEL_COLORS = {
  organic: "#047857",
  direct: "#0F4C81",
  referral: "#EA580C",
  social: "#7C3AED",
  campaign: "#F9C846",
  paid: "#DC2626",
};

const Stat = ({ value, label, testid, accent }) => (
  <div className="bg-white p-5" data-testid={testid}>
    <div className={`display text-3xl font-extrabold tracking-tighter ${accent || "text-topo"}`}>{value}</div>
    <div className="mono text-[10px] tracking-[0.22em] uppercase text-slate-500 mt-1">{label}</div>
  </div>
);

/** Totals strip + landing-channel split bar for the keyword tracker. */
export default function KeywordTotals({ totals, channels }) {
  const sum = channels.reduce((a, c) => a + c.landings, 0);
  return (
    <div className="mb-6">
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-px bg-slate-200 border border-slate-200">
        <Stat value={totals.landings} label="Landing visits" testid="kw-total-landings" />
        <Stat value={totals.organic_landings} label="From search engines" testid="kw-total-organic" accent="text-emerald-700" />
        <Stat value={totals.sessions} label="Sessions" testid="kw-total-sessions" />
        <Stat value={totals.views} label="Page views" testid="kw-total-views" />
        <Stat value={totals.leads} label="Leads attributed" testid="kw-total-leads" accent="text-orange-survey" />
      </div>
      {sum > 0 && (
        <div className="mt-3 border border-slate-200 bg-white p-4" data-testid="kw-channels">
          <div className="mono text-[10px] tracking-[0.22em] uppercase text-slate-500 mb-2">How visitors arrived</div>
          <div className="flex h-2.5 w-full overflow-hidden bg-slate-100">
            {channels.map((c) => (
              <div key={c.channel} style={{ width: `${(c.landings / sum) * 100}%`, background: CHANNEL_COLORS[c.channel] || "#94A3B8" }} />
            ))}
          </div>
          <div className="mt-2 flex flex-wrap gap-x-5 gap-y-1">
            {channels.map((c) => (
              <span key={c.channel} className="inline-flex items-center gap-1.5 mono text-[10px] tracking-[0.14em] uppercase text-slate-600" data-testid={`kw-channel-${c.channel}`}>
                <span className="h-2 w-2" style={{ background: CHANNEL_COLORS[c.channel] || "#94A3B8" }} />
                {c.channel} · {c.landings} ({Math.round((c.landings / sum) * 100)}%)
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
